class BeforeAfterSlider {
    constructor(container) {
      this.container = container;
      this.swiper = null;
      this.customSlider = {
        wrapper: null,
        slides: [],
        currentIndex: 0,
        visibleSlides: 3,
        gap: 16
      };
      this.slidersState = {};
      this.watchIntervals = {};
      this.slideElements = {};
      this.globalDragHandlers = null;
      this.globalListeners = [];
      this.init();
      this.container.beforeAfterSlider = this;
    }
  
    init() {
      if (window.innerWidth >= 990) {
        this.initCustomSlider();
      } else {
        this.initSwiper();
      }
      this.bindEvents();
    }
  
    initCustomSlider() {
      this.customSlider.wrapper = this.container.querySelector('.before-after-slider__custom-wrapper');
      if (!this.customSlider.wrapper) return;
      this.customSlider.slides = Array.from(this.container.querySelectorAll('.before-after-slider__custom-slide'));
      if (this.customSlider.slides.length === 0) return;
      this.customSlider.currentIndex = 0;
      this.updateSliderPosition();
      this.initCustomNavigation();
      setTimeout(() => {
        this.initBeforeAfterSliders();
      }, 200);
    }
  
    initSwiper() {
      if (window.innerWidth >= 990) return;
      const swiperElement = this.container.querySelector('.before-after-slider__swiper');
      if (!swiperElement) return;
      this.swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 18,
        loop: true,
        grabCursor: true,
        noSwiping: true,
        noSwipingClass: 'before-after-slider__slider-container',
        navigation: {
          nextEl: '.before-after-slider__nav-next',
          prevEl: '.before-after-slider__nav-prev'
        },
        pagination: {
          el: '.before-after-slider__pagination',
          clickable: true,
          dynamicBullets: false,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          }
        },
        on: {
          init: () => {
            setTimeout(() => {
              this.initBeforeAfterSliders();
            }, 200);
          }
        }
      });
    }
  
    updateSliderPosition() {
      if (!this.customSlider.wrapper || this.customSlider.slides.length === 0) return;
      const firstSlide = this.customSlider.slides[0];
      const slideWidth = firstSlide.offsetWidth;
      const translateX = (slideWidth + this.customSlider.gap) * this.customSlider.currentIndex;
      this.customSlider.wrapper.style.transform = `translateX(-${translateX}px)`;
    }
  
    initCustomNavigation() {
        const prevButton = this.container.querySelector('.before-after-slider__nav-button.prev');
        const nextButton = this.container.querySelector('.before-after-slider__nav-button.next');
        const paginationContainer = this.container.querySelector('.before-after-slider__custom-pagination');
        if (!prevButton || !nextButton || !paginationContainer) return;
    
        const totalSlides = this.customSlider.slides.length;
        const visible = this.customSlider.visibleSlides;
        const totalPages = Math.max(1, totalSlides - visible + 1);
    
        paginationContainer.innerHTML = '';
        for (let index = 0; index < totalPages; index++) {
          const dot = document.createElement('span');
          dot.className = `dot ${index === 0 ? 'active' : ''}`;
          dot.addEventListener('click', () => {
            this.goToSlide(index);
          });
          paginationContainer.appendChild(dot);
        }
    
        prevButton.addEventListener('click', () => {
          this.prevSlide();
        });
        nextButton.addEventListener('click', () => {
          this.nextSlide();
        });
      }
    
  
    goToSlide(index) {
      if (this.customSlider.slides.length === 0) return;
      const maxIndex = Math.max(0, this.customSlider.slides.length - this.customSlider.visibleSlides);
      const targetIndex = Math.max(0, Math.min(index, maxIndex));
      this.customSlider.currentIndex = targetIndex;
      this.updateSliderPosition();
      this.updatePaginationDots();
      setTimeout(() => {
        this.initBeforeAfterSliders();
      }, 100);
    }
  
    nextSlide() {
      if (this.customSlider.slides.length === 0) return;
      const maxIndex = Math.max(0, this.customSlider.slides.length - this.customSlider.visibleSlides);
      const nextIndex = Math.min(this.customSlider.currentIndex + 1, maxIndex);
      this.goToSlide(nextIndex);
    }
  
    prevSlide() {
      if (this.customSlider.slides.length === 0) return;
      const prevIndex = Math.max(0, this.customSlider.currentIndex - 1);
      this.goToSlide(prevIndex);
    }
  
    updatePaginationDots() {
      const dots = this.container.querySelectorAll('.before-after-slider__custom-pagination .dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.customSlider.currentIndex);
      });
    }
  
    setupPositionWatcher(handle, line, beforeImage, afterImage, slideIndex) {
      const watchInterval = setInterval(() => {
        const savedPosition = handle.dataset.currentPosition;
        const currentPosition = handle.style.left;
        if (this.slidersState[slideIndex] && this.slidersState[slideIndex].isDragging) {
          return;
        }
        if (savedPosition && savedPosition !== currentPosition) {
          handle.style.left = savedPosition;
          line.style.left = savedPosition;
          beforeImage.style.clipPath = `polygon(0% 0%, ${savedPosition} 0%, ${savedPosition} 100%, 0% 100%)`;
          afterImage.style.clipPath = `polygon(${savedPosition} 0%, 100% 0%, 100% 100%, ${savedPosition} 100%)`;
        }
      }, 100);
      this.watchIntervals[slideIndex] = watchInterval;
    }
  
    initBeforeAfterSliders() {
      Object.values(this.watchIntervals).forEach(interval => clearInterval(interval));
      this.watchIntervals = {};
      if (this.globalDragHandlers) {
        document.removeEventListener('mousemove', this.globalDragHandlers.move);
        document.removeEventListener('mouseup', this.globalDragHandlers.end);
        document.removeEventListener('touchmove', this.globalDragHandlers.move);
        document.removeEventListener('touchend', this.globalDragHandlers.end);
      }
      let slides;
      if (window.innerWidth >= 990) {
        slides = this.container.querySelectorAll('.before-after-slider__custom-slide');
      } else {
        slides = this.container.querySelectorAll('.before-after-slider__slide');
      }
      this.slideElements = {};
      slides.forEach((slide, slideIndex) => {
        const handle = slide.querySelector('.before-after-slider__slider-handle');
        const line = slide.querySelector('.before-after-slider__slider-line');
        const beforeImage = slide.querySelector('.before-after-slider__before-image');
        const afterImage = slide.querySelector('.before-after-slider__after-image');
        const sliderContainer = slide.querySelector('.before-after-slider__slider-container');
        if (!handle || !line || !beforeImage || !afterImage || !sliderContainer) return;
        this.slideElements[slideIndex] = {
          handle,
          line,
          beforeImage,
          afterImage,
          sliderContainer
        };
        this.slidersState[slideIndex] = {
          isDragging: false,
          wasDragging: false
        };
        const initialPosition = '50%';
        handle.style.left = initialPosition;
        line.style.left = initialPosition;
        beforeImage.style.clipPath = `polygon(0% 0%, ${initialPosition} 0%, ${initialPosition} 100%, 0% 100%)`;
        afterImage.style.clipPath = `polygon(${initialPosition} 0%, 100% 0%, 100% 100%, ${initialPosition} 100%)`;
        handle.dataset.currentPosition = initialPosition;
        this.setupPositionWatcher(handle, line, beforeImage, afterImage, slideIndex);
        handle.dataset.slideIndex = slideIndex;
        const onMouseDown = e => {
          const idx = parseInt(e.currentTarget.dataset.slideIndex, 10);
          const elements = this.slideElements[idx];
          if (elements) {
            this.onDragStart(e, idx, elements.handle, elements.line, elements.beforeImage, elements.afterImage, elements.sliderContainer);
          }
        };
        const onTouchStart = e => {
          const idx = parseInt(e.currentTarget.dataset.slideIndex, 10);
          const elements = this.slideElements[idx];
          if (elements) {
            this.onDragStart(e, idx, elements.handle, elements.line, elements.beforeImage, elements.afterImage, elements.sliderContainer);
          }
        };
        const onClick = e => {
          const idx = parseInt(e.currentTarget.dataset.slideIndex, 10);
          if (this.slidersState[idx] && this.slidersState[idx].wasDragging) {
            e.preventDefault();
            e.stopPropagation();
            this.slidersState[idx].wasDragging = false;
          }
        };
        handle.addEventListener('mousedown', onMouseDown);
        handle.addEventListener('touchstart', onTouchStart, { passive: false });
        handle.addEventListener('click', onClick);
      });
      this.globalDragHandlers = {
        move: e => {
          Object.keys(this.slidersState).forEach(idx => {
            if (this.slidersState[idx] && this.slidersState[idx].isDragging) {
              const elements = this.slideElements[idx];
              if (elements) {
                this.onDragMove(e, idx, elements.handle, elements.line, elements.beforeImage, elements.afterImage, elements.sliderContainer);
              }
            }
          });
        },
        end: e => {
          Object.keys(this.slidersState).forEach(idx => {
            if (this.slidersState[idx] && this.slidersState[idx].isDragging) {
              const elements = this.slideElements[idx];
              if (elements) {
                this.onDragEnd(e, idx, elements.handle, elements.line, elements.beforeImage, elements.afterImage, elements.sliderContainer);
              }
            }
          });
        }
      };
      document.addEventListener('mousemove', this.globalDragHandlers.move);
      document.addEventListener('mouseup', this.globalDragHandlers.end);
      document.addEventListener('touchmove', this.globalDragHandlers.move, { passive: false });
      document.addEventListener('touchend', this.globalDragHandlers.end);
    }
  
    onDragStart(e, slideIndex, handle, line, beforeImage, afterImage, sliderContainer) {
      if (!this.slidersState[slideIndex]) return;
      this.slidersState[slideIndex].isDragging = true;
      this.slidersState[slideIndex].wasDragging = false;
      if (this.swiper && window.innerWidth < 990) {
        this.swiper.disable();
      }
      e.preventDefault();
    }
  
    onDragMove(e, slideIndex, handle, line, beforeImage, afterImage, sliderContainer) {
      if (!this.slidersState[slideIndex] || !this.slidersState[slideIndex].isDragging) return;
      this.slidersState[slideIndex].wasDragging = true;
      const rect = sliderContainer.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const x = clientX - rect.left;
      const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
      const position = `${percentage}%`;
      handle.style.left = position;
      line.style.left = position;
      beforeImage.style.clipPath = `polygon(0% 0%, ${position} 0%, ${position} 100%, 0% 100%)`;
      afterImage.style.clipPath = `polygon(${position} 0%, 100% 0%, 100% 100%, ${position} 100%)`;
      handle.dataset.currentPosition = position;
      e.preventDefault();
    }
  
    onDragEnd(e, slideIndex, handle, line, beforeImage, afterImage, sliderContainer) {
      if (!this.slidersState[slideIndex] || !this.slidersState[slideIndex].isDragging) return;
      this.slidersState[slideIndex].isDragging = false;
      if (this.swiper && window.innerWidth < 990) {
        this.swiper.enable();
      }
      setTimeout(() => {
        if (this.slidersState[slideIndex]) {
          this.slidersState[slideIndex].wasDragging = false;
        }
      }, 100);
    }
  
    bindEvents() {
      const resizeHandler = () => {
        this.destroy();
        setTimeout(() => this.init(), 100);
      };
      window.addEventListener('resize', resizeHandler);
      this.globalListeners.push({ element: window, event: 'resize', handler: resizeHandler });
      const sectionLoadHandler = event => {
        if (event.target === this.container || event.target.contains(this.container)) {
          this.destroy();
          setTimeout(() => this.init(), 100);
        }
      };
      document.addEventListener('shopify:section:load', sectionLoadHandler);
      this.globalListeners.push({ element: document, event: 'shopify:section:load', handler: sectionLoadHandler });
      const blockSelectHandler = event => {
        if (!event.target.closest('.before-after-slider')) return;
        let slide, slideIndex;
        if (window.innerWidth >= 990) {
          slide = event.target.closest('.before-after-slider__custom-slide');
          if (slide) {
            slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
            this.goToSlide(slideIndex);
          }
        } else if (this.swiper) {
          slide = event.target.closest('.swiper-slide');
          if (slide) {
            slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
            this.swiper.slideTo(slideIndex);
          }
        }
      };
      document.addEventListener('shopify:block:select', blockSelectHandler);
      this.globalListeners.push({ element: document, event: 'shopify:block:select', handler: blockSelectHandler });
    }
  
    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      Object.values(this.watchIntervals).forEach(interval => {
        clearInterval(interval);
      });
      this.watchIntervals = {};
      if (this.globalDragHandlers) {
        document.removeEventListener('mousemove', this.globalDragHandlers.move);
        document.removeEventListener('mouseup', this.globalDragHandlers.end);
        document.removeEventListener('touchmove', this.globalDragHandlers.move);
        document.removeEventListener('touchend', this.globalDragHandlers.end);
        this.globalDragHandlers = null;
      }
      this.globalListeners.forEach(({ element, event, handler, options }) => {
        element.removeEventListener(event, handler, options);
      });
      this.globalListeners = [];
      this.slidersState = {};
      this.slideElements = {};
      this.customSlider = {
        wrapper: null,
        slides: [],
        currentIndex: 0,
        visibleSlides: 3,
        gap: 16
      };
    }
  }
  
  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.before-after-slider');
    sections.forEach(container => {
      new BeforeAfterSlider(container);
    });
  });
  
  document.addEventListener('shopify:section:load', function (event) {
    const container = event.target.querySelector('.before-after-slider');
    if (container) {
      new BeforeAfterSlider(container);
    }
  });
  
  document.addEventListener('shopify:section:unload', function (event) {
    const container = event.target.querySelector('.before-after-slider');
    if (container && container.beforeAfterSlider) {
      container.beforeAfterSlider.destroy();
    }
  });
  